import { authRoutes } from '@manager/modules/auth/auth-routes';
import { bookingRoutes } from '@manager/modules/booking/booking-routes';
import { routesConnectedApps } from '@manager/modules/connected-apps/connected-apps-routes';
import { creditNotesRoutes } from '@manager/modules/credit-notes/credit-notes-routes';
import { customerRoutes } from '@manager/modules/customer/customer-routes';
import { dashboardRoutes } from '@manager/modules/dashboard/dashboard-routes';
import { routesDeposit } from '@manager/modules/deposits/routes-deposit';
import { discountRoutes } from '@manager/modules/discount/discount-routes';
import { documentTemplatesRoutes } from '@manager/modules/document-templates/document-templates-routes';
import { facilityMapRoutes } from '@manager/modules/facility-map/facility-map-routes';
import { routesInsurance } from '@manager/modules/insurances/routes-insurance';
import { invoicesRoutes } from '@manager/modules/invoices/invoices-routes';
import { routesLocationSettings } from '@manager/modules/location-settings/routes-location-settings';
import { routesLocation } from '@manager/modules/location/routes-locations';
import { pdfRendererRoutes } from '@manager/modules/pdf-renderer/pdf-renderer-routes';
import { routesProduct } from '@manager/modules/products/routes-products';
import { publicApiRoutes } from '@manager/modules/public-api/public-api-routes';
import { tasksRoutes } from '@manager/modules/tasks/task-routes';
import { unitTypeRoutes } from '@manager/modules/unit-types/unit-type-routes';
import { unitsRoutes } from '@manager/modules/units/units-routes';
import { routesUser } from '@manager/modules/users/routes-users';
import type { RouteMetaConfig } from '@manager/types/router';
import { routesEmailDomain } from '@manager/views/email-domains/routes-email-domain';
import { routesEmailTemplate } from '@manager/views/email-templates/routes-email-template';
import { routesEmail } from '@manager/views/emails/routes-emails';
import { routesGlobalSettings } from '@manager/views/global-settings/routes-global-settings';
import { routesTenant } from '@manager/views/tenants/routes-tenants';

import { routeNames } from './route-names';

const routes: RouteMetaConfig[] = [
  ...routesTenant,
  ...dashboardRoutes,
  ...routesLocation,
  ...unitTypeRoutes,
  ...bookingRoutes,
  ...customerRoutes,
  ...routesInsurance,
  ...invoicesRoutes,
  ...creditNotesRoutes,
  ...unitsRoutes,
  ...routesDeposit,
  ...routesProduct,
  ...discountRoutes,
  ...routesEmail,
  ...routesEmailTemplate,
  ...routesEmailDomain,
  ...routesLocationSettings,
  ...routesGlobalSettings,
  ...routesConnectedApps,
  ...routesUser,
  ...facilityMapRoutes,
  ...pdfRendererRoutes,
  ...documentTemplatesRoutes,
  ...tasksRoutes,
  ...authRoutes,
  ...publicApiRoutes,
  {
    path: '/maintenance',
    name: routeNames.maintenance,
    component: () => import('../views/maintenance/MaintenanceView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'tenants.view',
    },
  },
  {
    path: '/voting-portal',
    name: routeNames.votingPortal,
    component: () => import('../views/voting-portal/VotingPortalPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'voting_portal.view',
    },
  },
  {
    path: '/forbidden',
    name: routeNames.forbidden,
    component: () => import('../views/errors/ErrorView.vue'),
    props: {
      type: 'forbidden',
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: routeNames.notFound,
    component: () => import('../views/errors/ErrorView.vue'),
  },
];

export default routes;
